import * as yup from 'yup';
import { StatBadge } from '@web/atoms';
import { nullableImageFromCMSSchema } from '../schemas';

const optionalStatFromCMS = value => {
  if (value === '' || value === null || value === undefined) {
    return undefined;
  }

  const stat = Number(value);
  return Number.isFinite(stat) ? stat : undefined;
};

const hasCmsIcon = icon => Boolean(icon?.filename || icon?.src);

export const component = StatBadge;

export const schema = yup
  .object({
    stat: yup.number().nullable(),
    icon: nullableImageFromCMSSchema,
    color: yup.string(),
    backgroundColor: yup.string(),
    size: yup.number(),
  })
  .transform(value => {
    if (!value) return value;

    //* Prefer icon mode when present; treat blank CMS stats as omitted.
    const icon = value.icon;
    const stat = hasCmsIcon(icon) ? undefined : optionalStatFromCMS(value.stat);

    return {
      stat,
      icon,
      color: value.color || undefined,
      backgroundColor: value.background_color || undefined,
      size: value.size || undefined,
    };
  });
